import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/caduceo.png'


const _withScopeId = n => (_pushScopeId("data-v-246ba7ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "grid-item"
}
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  height: "10",
  width: "50"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "plus" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "title"
}
const _hoisted_5 = { class: "titlenote" }
const _hoisted_6 = {
  key: 2,
  class: "title"
}
const _hoisted_7 = {
  key: 3,
  class: "title"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { class: "title" }
const _hoisted_11 = { class: "titlenote" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = {
  key: 0,
  class: "title"
}
const _hoisted_17 = { class: "titlenote" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { key: 2 }
const _hoisted_21 = {
  key: 6,
  class: "date-disc"
}
const _hoisted_22 = { class: "title" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "titlenote" }
const _hoisted_26 = {
  key: 2,
  class: "titlenote"
}
const _hoisted_27 = {
  key: 7,
  class: "date-disc"
}
const _hoisted_28 = { class: "title" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { style: {"font-size":"15px"} }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = { style: {"font-size":"15px"} }
const _hoisted_37 = { key: 2 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = { style: {"font-size":"15px"} }
const _hoisted_41 = {
  key: 8,
  class: "date-disc"
}
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 1,
  style: {"margin-left":"-5em"}
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_46 = { style: {"font-size":"15px"} }
const _hoisted_47 = {
  key: 9,
  class: "date-disc"
}
const _hoisted_48 = { class: "title" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = { class: "titlenote" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 10,
  class: "date-disc"
}
const _hoisted_54 = { class: "title" }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = { key: 1 }
const _hoisted_58 = {
  key: 1,
  class: "horizontalLineSmall"
}
const _hoisted_59 = {
  key: 2,
  class: "grid-item"
}
const _hoisted_60 = {
  class: "column",
  style: {"display":"flex","align-items":"center","justify-content":"center"}
}
const _hoisted_61 = {
  key: 0,
  class: "title"
}
const _hoisted_62 = {
  key: 1,
  class: "title"
}
const _hoisted_63 = {
  key: 2,
  class: "titlenote"
}
const _hoisted_64 = {
  key: 3,
  class: "titlenote"
}

import { CollapsableModel } from "@/../../EshJSLib/models/CollapsableModel";
import { patientStore } from "@/store/patient";
import CollapsibleRowActions from "@/layout/collapsible/CollapsibleRowActions.vue";
import { storeToRefs } from "pinia";
import { downloadFileService } from "@/../../EshJSLib/services/donwloadService";
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'CollapsibleRow',
  props: {
  row: Object,
  data: Object,
},
  emits: ["rowActions"],
  setup(__props, { emit }) {

const props = __props;

const store = patientStore();



const layoutType = (() => {
  const type = props.data?.data;

  if (['contattiemergenza', 'contattialtro'].includes(type)) return 'contatti';
  if (['visite'].includes(type)) return 'visite';
  if (type === 'tbl_parametri_vitalis') return 'rilevazioni';
  if (type === 'associated_doctors') return 'associati';
  if (type === 'avalailable_doctors') return 'disponibili';
  if (type === 'diagnosi') return 'diagnosi';
  if (type === 'tbl_terapie') return 'farmaci';
  if (['tbl_files', 'kardias'].includes(type)) return 'files';
  if ([
      'centri_convenzionati_laboratory_analisi',
      'centri_convenzionati_radiologici',
      'centri_convenzionati_specialistici'
    ].includes(type)) return 'centri';

  return 'default';
})();

const defineVisibility = computed(() => {
  const vis = props.row.visibility;
  switch (vis) {
    case 1: return 'Totale';
    case 2: return 'Minima';
    case 3: return 'Parziale';
    default: return 'Non specificato';
  }
});

const defineConfidentiality = computed(() => {
  const conf = props.row.assegnazione_confidenzialita;
  switch (conf) {
    case 1: return 'Nessuna Restrizione';
    case 2: return 'Basso';
    case 3: return 'Moderato';
    case 4: return 'Normale';
    case 5: return 'Riservato';
    case 6: return 'Strettamente riservato';
    default: return 'Non specificato';
  }
});

function formatDate(dateString: string) {
  const date = new Date(dateString);
  return date.toLocaleDateString('it-IT');
}



function rowAction(type: string, row: any) {
  emit("rowActions", type, row);
}

function consolPoint(row: any, clm: string) {
  try {
    return eval("row." + clm);
  } catch (e) {
    console.log(e);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.data.filter == null || __props.row[__props.data.filter]?.toString() === __props.data.filterValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.columns, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              (consolPoint(__props.row, item.author) != consolPoint(__props.row, item.patient))
                ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                : _createCommentVNode("", true),
              _hoisted_3,
              (_unref(layoutType) === 'default')
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)) + " ", 1),
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                      ])
                    ])
                  ]))
                : (_unref(layoutType) === 'centri')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (index != 2)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : (_unref(layoutType) === 'contatti')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (index === 0)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                      ]))
                    : (_unref(layoutType) === 'visite')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1),
                          _createElementVNode("div", _hoisted_11, [
                            (item.columnNameLabel)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                  _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                  _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item.columnNameLabel2)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
                                  _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                  _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                ]))
                              : _createCommentVNode("", true),
                            (item.columnNameLabel3)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                  _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                                  _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : (_unref(layoutType) === 'rilevazioni')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(formatDate(consolPoint(__props.row, item.columnNameDescrption))), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_17, [
                              (item.columnNameLabel)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.columnNameLabel2)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (item.columnNameLabel3)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_20, [
                                    _createElementVNode("b", null, _toDisplayString(item.columnNameLabel3), 1),
                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef3)), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : (_unref(layoutType) === 'diagnosi')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                (index === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                  : _createCommentVNode("", true),
                                (item.columnNameRef === 'diagnosiDetails.careprovider')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _createTextVNode(_toDisplayString(item.columnNameLabel) + " ", 1),
                                      _createElementVNode("p", _hoisted_25, [
                                        _createElementVNode("b", null, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                      _createElementVNode("p", null, [
                                        _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                        _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                      ])
                                    ]))
                              ])
                            ]))
                          : (_unref(layoutType) === 'associati')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                  (index === 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        (item.columnNameDescrption === 'visibility')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                              _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                              _hoisted_32,
                                              _createElementVNode("span", _hoisted_33, _toDisplayString(defineVisibility.value), 1)
                                            ]))
                                          : (item.columnNameDescrption === 'assegnazione_confidenzialita')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                                _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                                _hoisted_35,
                                                _createElementVNode("span", _hoisted_36, _toDisplayString(defineConfidentiality.value), 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                                (item.columnNameLabel)
                                                  ? (_openBlock(), _createElementBlock("b", _hoisted_38, _toDisplayString(item.columnNameLabel) + ":", 1))
                                                  : _createCommentVNode("", true),
                                                _hoisted_39,
                                                _createElementVNode("span", _hoisted_40, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                              ]))
                                      ]))
                                ])
                              ]))
                            : (_unref(layoutType) === 'disponibili')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                  _createElementVNode("div", _hoisted_42, [
                                    (index === 0)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_43, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                                      : (index === 2)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createElementVNode("b", null, _toDisplayString(item.columnNameLabel) + ":", 1),
                                            _hoisted_45,
                                            _createElementVNode("span", _hoisted_46, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                  ])
                                ]))
                              : (_unref(layoutType) === 'farmaci')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1),
                                      _hoisted_49,
                                      _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameSubDescrption)), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      (item.columnNameDescrption === 'cp_display')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                            _createElementVNode("b", null, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1),
                                            _createElementVNode("p", null, [
                                              _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                              _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                            _createElementVNode("p", null, [
                                              _createElementVNode("b", null, _toDisplayString(item.columnNameLabel), 1),
                                              _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                            ]),
                                            _createElementVNode("p", null, [
                                              _createElementVNode("b", null, _toDisplayString(item.columnNameLabel2), 1),
                                              _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                            ])
                                          ]))
                                    ])
                                  ]))
                                : (_unref(layoutType) === 'files')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        (index != 4)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                              _createTextVNode(_toDisplayString(consolPoint(__props.row, item.columnNameDescrption)) + " " + _toDisplayString(consolPoint(__props.row, item.columnNameDescriptionMobile)) + " ", 1),
                                              (item.columnNameLabel)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_56, [
                                                    _createElementVNode("b", null, [
                                                      _createElementVNode("span", null, _toDisplayString(item.columnNameLabel), 1)
                                                    ]),
                                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1)
                                                  ]))
                                                : _createCommentVNode("", true),
                                              (item.columnNameLabel2)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_57, [
                                                    _createElementVNode("b", null, [
                                                      _createElementVNode("span", null, _toDisplayString(item.columnNameLabel2), 1)
                                                    ]),
                                                    _createTextVNode(" " + _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode(CollapsibleRowActions, {
            data: __props.data,
            onAction: _cache[0] || (_cache[0] = (n) => rowAction(n, __props.row))
          }, null, 8, ["data"])
        ]))
      : _createCommentVNode("", true),
    (__props.data.filter == null || __props.row[__props.data.filter] === __props.data.filterValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_58))
      : _createCommentVNode("", true),
    (__props.data?.textOrRow)
      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.columns, (item, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("div", _hoisted_60, [
                (item.columnNameDescrption != undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(consolPoint(__props.row, item.columnNameDescrption)), 1))
                  : _createCommentVNode("", true),
                (item.columnNameSubDescrption != undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_62, _toDisplayString(consolPoint(__props.row, item.columnNameSubDescrption)), 1))
                  : _createCommentVNode("", true),
                (item.columnNameRef != undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(consolPoint(__props.row, item.columnNameRef)), 1))
                  : _createCommentVNode("", true),
                (item.columnNameRef2 != undefined)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(consolPoint(__props.row, item.columnNameRef2)), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})